var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import CustomMarshalingInterpreter from '@cdo/apps/lib/tools/jsinterpreter/CustomMarshalingInterpreter';
import { commands as audioCommands } from '@cdo/apps/lib/util/audioApi';
import * as danceMsg from '../locale';
import { ASSET_BASE } from '../constants';
import Lab2MetricsReporter from '@cdo/apps/lab2/Lab2MetricsReporter';
import utils from '../utils';
// TODO: The Dance Party repo currently does not export types, so we need
// use require() to import these components. We should add declaration files
// to the Dance Party repo and switch to using import statements.
var DanceParty = require('@code-dot-org/dance-party/src/p5.dance');
var DanceAPI = require('@code-dot-org/dance-party/src/api');
var ResourceLoader = require('@code-dot-org/dance-party/src/ResourceLoader');
var danceCode = require('@code-dot-org/dance-party/src/p5.dance.interpreted.js');
var allEvents = {
    runUserSetup: { code: 'runUserSetup();' },
    runUserEvents: { code: 'runUserEvents(events);', args: ['events'] },
    getCueList: { code: 'return getCueList();' },
};
/**
 * Handles program execution for Dance Party and wraps the native Dance Party API.
 *
 * TODO: Currently only used by Lab2 Dance. Can we share with Dance.js?
 */
var ProgramExecutor = /** @class */ (function () {
    function ProgramExecutor(container, onPuzzleComplete, isReadOnlyWorkspace, recordReplayLog, customHelperLibrary, validationCode, onEventsChanged, readonlyCode, // Allows us to supply the student code early if we're in a read-only workspace.
    nativeAPI // For testing
    ) {
        if (nativeAPI === void 0) { nativeAPI = undefined; }
        var _this = this;
        this.livePreviewActive = false;
        this.currentlyPlayingSong = null;
        this.hooks = {};
        this.validationCode = validationCode;
        this.onEventsChanged = onEventsChanged;
        this.nativeAPI =
            nativeAPI ||
                new DanceParty({
                    onPuzzleComplete: onPuzzleComplete,
                    playSound: this.playSong,
                    recordReplayLog: recordReplayLog,
                    showMeasureLabel: !isReadOnlyWorkspace,
                    onHandleEvents: function (currentFrameEvents) {
                        return _this.handleEvents(currentFrameEvents);
                    },
                    onInit: function (nativeAPI) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            this.init(nativeAPI, isReadOnlyWorkspace, readonlyCode);
                            return [2 /*return*/];
                        });
                    }); },
                    spriteConfig: new Function('World', customHelperLibrary || ''),
                    container: container,
                    i18n: danceMsg,
                    resourceLoader: new ResourceLoader(ASSET_BASE),
                    logger: Lab2MetricsReporter,
                });
    }
    /**
     * Execute the program. Compiles student code and hands off to the native API to run.
     */
    ProgramExecutor.prototype.execute = function (code, songMetadata) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, timestamps;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // TODO: Dance.js checks for unwanted top blocks and duplicate variables in for loops
                        // before executing. We should do something similar here.
                        _a = this;
                        return [4 /*yield*/, this.compileAllCode(code)];
                    case 1:
                        // TODO: Dance.js checks for unwanted top blocks and duplicate variables in for loops
                        // before executing. We should do something similar here.
                        _a.hooks = _b.sent();
                        if (!this.hooks.runUserSetup || !this.hooks.getCueList) {
                            Lab2MetricsReporter.logWarning('Missing required hooks in compiled code');
                            return [2 /*return*/];
                        }
                        this.hooks.runUserSetup();
                        timestamps = this.hooks.getCueList();
                        this.nativeAPI.addCues(timestamps);
                        if (this.validationCode) {
                            this.nativeAPI.registerValidation(utils.getValidationCallback(this.validationCode));
                        }
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                _this.nativeAPI.play(songMetadata, function (success) {
                                    success ? resolve() : reject();
                                });
                            })];
                }
            });
        });
    };
    /**
     * Show a static preview of the program. Compiles student code and calls on the native API to draw a frame.
     */
    ProgramExecutor.prototype.staticPreview = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, previewDraw;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.reset();
                        _a = this;
                        return [4 /*yield*/, this.preloadSpritesAndCompileCode(code, 'runUserSetup')];
                    case 1:
                        _a.hooks = _b.sent();
                        if (!this.hooks.runUserSetup) {
                            Lab2MetricsReporter.logWarning('Missing required hook in compiled code');
                            return [2 /*return*/];
                        }
                        previewDraw = function () {
                            _this.nativeAPI.setEffectsInPreviewMode(true);
                            // the user setup hook initializes effects,
                            // needs to happen in preview mode for some effects (eg, tacos)
                            if (!_this.hooks.runUserSetup) {
                                return;
                            }
                            _this.hooks.runUserSetup();
                            // redraw() (rather than draw()) is p5's recommended way
                            // of drawing once.
                            _this.nativeAPI.p5_.redraw();
                            _this.nativeAPI.setEffectsInPreviewMode(false);
                        };
                        // This is the mechanism p5 uses to queue draws,
                        // so we do the same so we end up after any queued draws.
                        window.requestAnimationFrame(previewDraw);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Show a live preview of the program. Compiles student code and calls on the native API to run the live preview.
     */
    ProgramExecutor.prototype.startLivePreview = function (code, songMetadata, durationMs) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.reset();
                        this.livePreviewActive = true;
                        return [4 /*yield*/, this.updateLivePreview(code, songMetadata, durationMs)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update the currently playing live preview.
     */
    ProgramExecutor.prototype.updateLivePreview = function (code, songMetadata, durationMs) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.livePreviewActive) {
                            console.warn('Update live preview called before starting live preview');
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.preloadSpritesAndCompileCode(code, 'runUserSetup')];
                    case 1:
                        _a.hooks = _b.sent();
                        if (!this.hooks.runUserSetup) {
                            Lab2MetricsReporter.logWarning('Missing required hook in compiled code');
                            return [2 /*return*/];
                        }
                        this.hooks.runUserSetup();
                        this.nativeAPI.livePreview(utils.getSongMetadataForPreview(songMetadata), durationMs);
                        return [2 /*return*/];
                }
            });
        });
    };
    ProgramExecutor.prototype.isLivePreviewRunning = function () {
        return this.livePreviewActive;
    };
    ProgramExecutor.prototype.reset = function () {
        // Only stop audio if this executor had started playing a song.
        if (this.currentlyPlayingSong) {
            audioCommands.stopSound({ url: this.currentlyPlayingSong });
            this.currentlyPlayingSong = null;
        }
        this.nativeAPI.reset();
        this.livePreviewActive = false;
    };
    ProgramExecutor.prototype.getReplayLog = function () {
        return this.nativeAPI.getReplayLog();
    };
    ProgramExecutor.prototype.destroy = function () {
        this.reset();
        this.nativeAPI.teardown();
    };
    ProgramExecutor.prototype.compileAllCode = function (studentCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.preloadSpritesAndCompileCode(studentCode, 'runUserSetup', 'getCueList', 'runUserEvents')];
            });
        });
    };
    /**
     * Prepares student code for execution. Preloads any sprites referenced in the code
     * and compiles the program.
     *
     * @param code student code
     * @param eventNames events to generate hooks for
     * @returns Generated hooks for the compiled code.
     */
    ProgramExecutor.prototype.preloadSpritesAndCompileCode = function (code) {
        var eventNames = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            eventNames[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var charactersReferenced, events, nativeAPI, api, fullCode, hooks;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        charactersReferenced = utils.computeCharactersReferenced(code);
                        return [4 /*yield*/, this.nativeAPI.ensureSpritesAreLoaded(charactersReferenced)];
                    case 1:
                        _a.sent();
                        events = {};
                        eventNames.forEach(function (name) {
                            events[name] = allEvents[name];
                        });
                        nativeAPI = this.nativeAPI;
                        api = new DanceAPI(nativeAPI);
                        fullCode = danceCode + code;
                        hooks = {};
                        CustomMarshalingInterpreter.evalWithEvents(api, events, fullCode, undefined).hooks.forEach(function (hook) {
                            hooks[hook.name] = hook.func;
                        });
                        return [2 /*return*/, hooks];
                }
            });
        });
    };
    ProgramExecutor.prototype.init = function (nativeAPI, isReadOnlyWorkspace, readonlyCode) {
        return __awaiter(this, void 0, void 0, function () {
            var charactersReferenced;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(isReadOnlyWorkspace && readonlyCode)) return [3 /*break*/, 2];
                        charactersReferenced = utils.computeCharactersReferenced(readonlyCode);
                        return [4 /*yield*/, nativeAPI.ensureSpritesAreLoaded(charactersReferenced)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ProgramExecutor.prototype.handleEvents = function (currentFrameEvents) {
        var _a;
        if (this.livePreviewActive) {
            // We don't want to handle events while live preview is active.
            return;
        }
        if (!this.hooks.runUserEvents) {
            Lab2MetricsReporter.logWarning('Missing required hook in compiled code');
            return;
        }
        this.hooks.runUserEvents(currentFrameEvents);
        (_a = this.onEventsChanged) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    ProgramExecutor.prototype.playSong = function (url, callback, onEnded) {
        var _this = this;
        var callbackWrapper = function (playSuccess) {
            if (playSuccess) {
                _this.currentlyPlayingSong = url;
            }
            callback(playSuccess);
        };
        var onEndedWrapper = function () {
            _this.currentlyPlayingSong = null;
            onEnded();
        };
        audioCommands.playSound({
            url: url,
            callback: callbackWrapper,
            onEnded: onEndedWrapper,
        });
    };
    return ProgramExecutor;
}());
export default ProgramExecutor;
